export const API_ROUTES = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
  },
  CONNECT: {
    ACCOUNTS_ME: '/connect/accounts/me',
  },
} as const;
